'use strict';

const Mn = require('backbone.marionette');
const GroupAction = require('common/domain/action/group');
const GroupRepository = require('common/domain/repository/group');
const MyActionStatusRepository = require('balus/domain/repository/my/action-status');
const MyActionStatusListView = require('balus/ui/view/body/my-actions/content/action-status-list');
const GroupFilterView = require('balus/ui/view/body/user/content/group-filter');
const Template = require('balus/ui/template/body/my-actions/content/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        groupFilter: '.group-filter',
        myActions: '.my-actions'
    },
    childViewEvents: {
        'filter:all': 'onAllGroup',
        'group:select': 'onGroupSelect'
    },

    initialize: function() {
        this._filteredGroup = null;
    },

    onDomRefresh: function() {
        GroupAction.fetchGroupsOnce({excludeMembers: true})
            .then(() => {
                const groups = GroupRepository.getGroups();
                this.showChildView('groupFilter', new GroupFilterView({
                    collection: groups,
                    filteredGroup: this._filteredGroup
                }));
            });

        MyActionStatusRepository.find(this._filteredGroup).fetchOnce(5)
            .then(actionStatuses => {
                this.showChildView('myActions', new MyActionStatusListView({
                    collection: actionStatuses,
                    group: this._filteredGroup
                }));
            });
    },

    onGroupSelect: function(child) {
        this._filteredGroup = child.model;
        this.render();
    },

    onAllGroup: function() {
        this._filteredGroup = null;
        this.render();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/my-actions/content/index.js